// 🆕 [Phase 56.1] Extrait de CalendrierProduction.jsx — légende footer du calendrier.
// Composant purement présentationnel : affiche les chefs d'équipe (avec couleurs),
// les types de BT (Solo / SC / Interne / RDV) et la légende des icônes (☀️ ☁️ 🌧️ ⛔ ...).
function CalendarLegende({ bons, employees, showAgenda }) {
  return (
    <div className="px-4 py-3 border-t bg-white">
      <div className="flex flex-wrap items-start gap-x-4 gap-y-2 text-xs">
        {/* Chefs d'équipe — uniquement les vrais chefs (pas les peintres assignés en solo) */}
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-gray-500 font-semibold uppercase tracking-wider text-[10px]">Chefs :</span>
          {[...new Map(bons.filter(b => {
            if (!b.chef_equipe_nom) return false;
            const emp = employees.find(e => e.id === b.chef_equipe_id);
            // 🎨 [v13.53] Exclure les peintres assignés solo (non-chefs réels) —
            // ils tomberont dans "Sans chef" (gris #94a3b8 depuis v13.53,
            // mauve avant v13.53).
            return !!emp && (emp.role_terrain === 'chef_equipe' || emp.type_employe === 'chef_equipe');
          }).map(b => {
            const emp = employees.find(e => e.id === b.chef_equipe_id);
            return [b.chef_equipe_id, { nom: b.chef_equipe_nom, color: emp?.couleur_equipe || '#3B82F6' }];
          })).values()].map(({ nom, color }) => (
            <span key={nom} className="flex items-center gap-1">
              <span className="w-3 h-3 rounded-full ring-1 ring-slate-300" style={{ backgroundColor: color }} />
              {nom}
            </span>
          ))}
        </div>

        <span className="hidden md:inline-block h-4 w-px bg-slate-200" />

        {/* États & types */}
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-gray-500 font-semibold uppercase tracking-wider text-[10px]">Types :</span>
          <span className="flex items-center gap-1" title="BT sans chef d'équipe (ou avec un peintre seul assigné)">
            <span className="w-3 h-3 rounded-full ring-1 ring-slate-300" style={{ backgroundColor: '#94a3b8' }} />
            Solo / Sans chef
          </span>
          <span className="flex items-center gap-1" title="Service Call (pastille jaune)">
            <span className="w-3 h-3 rounded-full ring-1 ring-yellow-300" style={{ backgroundColor: '#EAB308' }} />
            Service Call
          </span>
          {/* 🆕 2026-05-23 — BT interne (réunion, lavage, démontage, etc.) */}
          <span className="flex items-center gap-1" title="Bon de travail interne (réunion, formation, maintenance interne, etc.)">
            <span className="w-3 h-3 rounded-full ring-1 ring-slate-300" style={{ backgroundColor: '#64748B' }} />
            BT interne
          </span>
          {showAgenda && (
            <span className="flex items-center gap-1" title="Rendez-vous CRM">
              <span className="w-3 h-3 rounded-full bg-violet-500" />
              RDV
            </span>
          )}
        </div>

        <span className="hidden md:inline-block h-4 w-px bg-slate-200" />

        {/* 🆕 2026-05-14 — Légende des icônes alignée sur la réalité du calendrier.
            Retirés : 🔒 Verrouillé, 🚫 Absent, 📍 GPS à valider (jamais affichés sur les BT).
            ⛔ Jour fixe : icône alignée avec ce qui s'affiche sur les BT (avant : 📌). */}
        <div className="flex flex-wrap items-center gap-3">
          <span className="text-gray-500 font-semibold uppercase tracking-wider text-[10px]">Icônes :</span>
          <span className="flex items-center gap-1 text-amber-700" title="Travaux extérieurs (beau temps)">☀️ Extérieur</span>
          <span className="flex items-center gap-1 text-gray-600" title="Travaux intérieurs (météo sans impact)">☁️ Intérieur</span>
          <span className="flex items-center gap-1 text-blue-600" title="Pluie prévue">🌧️ Pluie</span>
          <span className="flex items-center gap-1 text-gray-600" title="Lavage de pression">🚿 Lavage</span>
          <span className="flex items-center gap-1 text-gray-600" title="Nacelle / équipement levage">🏗️ Nacelle</span>
          <span className="flex items-center gap-1 text-purple-700" title="Date fixée : ne peut être déplacée">⛔ Jour fixe</span>
          <span className="flex items-center gap-1 text-red-600" title="Conflit / employé en double">⚠️ Conflit</span>
        </div>
      </div>
    </div>
  );
}

export default CalendarLegende;
